<span *ngIf="price >= 0">+</span><span *ngIf="price < 0">-</span>
{{ price | currency: currency:"symbol":undefined:locale }}
